import { render } from "./ModalFeeback.vue?vue&type=template&id=00744c5c"
import script from "./ModalFeeback.vue?vue&type=script&lang=js"
export * from "./ModalFeeback.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__